'use strict';

angular.module('shiftTraderApp')
  .directive('saDrawShiftBar', function (WorkPeriodStore, PositioningService, saViewShiftRowHeightInt, $timeout, $compile,
                                        TimeService, $rootScope, toastr,
                                        Session, MWPHighlightService, saDrawShiftBarHeight, WorkPeriods) {
    var renderQuarterHourIntervals = '';

    (function() {
      _.each(_.range((24 + 6 + 6) * 4), function(i) {
        renderQuarterHourIntervals += '<div class="quarter-hour-interval" style="left:' + i * 10 + 'px" data-interval="' + i + '"><div class="inner"></div></div>';
      });
    })();

    var genDynamicContentContainer = function(shiftTwix) {
      return '<div class="shift_time_container no_clear">' + TimeService.minimalTwixFormat(shiftTwix, true, true) + '</div>';
    };


    var genActiveIntervalInnerTemplate = function(shiftTwix) {
      return '<div class="dynamic_content_container no_clear"><div class="time">' + genDynamicContentContainer(shiftTwix) + '</div>' +
        '<div class="spinner_container"><i class="icon-spinner icon-spin"</div></div>';
    };

    var timeIndicatorTemplate = '<div class="sa_draw_shift_bar_hover_time"></div>';

    return {
      template: '<div class="quarter-hour-interval-container"></div>',
      restrict: 'A',
      link: function(scope, element, attrs, ctrl) {
        var allQuarters;
        var quarterHourIntervalContainer = element.find('.quarter-hour-interval-container');

        var renderIntervals = function() {
          quarterHourIntervalContainer.removeClass('interacting').empty();

          quarterHourIntervalContainer.html(renderQuarterHourIntervals);
          allQuarters = _.map(element.find('.quarter-hour-interval'), function(ele) {return $(ele);});

          if (scope.drawShiftBarState && !$rootScope.isIpad) {
            initIntervalHover();
          }
        };

        function setDrawShiftBarStateClass(isActive) {
          var e = $(element);

          if (isActive) {
            e.addClass('active');
          } else {
            e.removeClass('active')
          }
        }

        scope.$watch('drawShiftBarState', function(newVal, oldVal) {
          if (newVal !== oldVal) {
            setDrawShiftBarStateClass(newVal);

            if (newVal) {
              renderIntervals();

              if (!$rootScope.isIpad) {
                initIntervalHover();
              }
            } else {
              $timeout(function() {
                quarterHourIntervalContainer.empty();
              }, 500);
            }
          }
        });


        scope.positionBarStyles = {};
        scope.positionBarStyles['min-height'] = saViewShiftRowHeightInt + 'px';

        scope.intervals = _.range((24 + 6 + 6) * 4);

        var timeTooltips;

        var initTimeTooltips = function() {
          timeTooltips = {
            start: $(element).find('.sa_draw_shift_bar_hover_time')
          };
        };

        var updateTimes = function() {
          timeTooltips.start.html(TimeService.minimalMomentFormat(drawnShift.startTime, true, true));
          if (state.timeContainer) {
            state.timeContainer.html(TimeService.minimalTwixFormat(drawnShift.startTime.twix(drawnShift.endTime), true, true));
          }
        };

        var drawnShift = {};

        var getDateForIntervalNum = function(intervalNum) {
          var baseMmnt;
          if (intervalNum < (6 * 4)) {
            baseMmnt = moment(scope.currentDate).subtract(22, 'hours').hours(0).minutes(0).seconds(0).milliseconds(0);
            return baseMmnt.hours( 18 + Math.floor(intervalNum / 4)).minutes( (intervalNum % 4) * 15 );
          } else if (intervalNum >= (6 * 4) && intervalNum < (30 * 4)) {
            baseMmnt = moment(scope.currentDate).hours(0).minutes(0).seconds(0).milliseconds(0);
            return baseMmnt.hours( Math.floor(intervalNum / 4) - 6).minutes( (intervalNum % 4) * 15 );
          } else {
            baseMmnt = moment(scope.currentDate).add(46, 'hours').hours(0).minutes(0).seconds(0).milliseconds(0);
            return baseMmnt.hours( Math.floor(intervalNum / 4) - 30).minutes( (intervalNum % 4) * 15 );
          }
        };

        var state = {
          interactElement: null,
          timeContainer: null
        };

        var reinitBar = function() {
          state.interactElement = null;
          renderIntervals();
          drawnShift = {};
          element.find('.quarter-hour-interval.included.manual').remove();
        };

        var scrollContainer = $('.measuring-tape-container');

        var hoverInTimeout = null;
        var timeIndicatorElement = null;

        var initIntervalHover = function() {
          element.find('.quarter-hour-interval').hover(function(e) {
            var autoHoverOutTimeout, intervalNum;

            if ($(e.target).hasClass('quarter-hour-interval')) {
              if (hoverInTimeout) {
                $timeout.cancel(hoverInTimeout);
              }

              hoverInTimeout = $timeout(function() {
                if (autoHoverOutTimeout) {
                  $timeout.cancel(autoHoverOutTimeout);
                }

                if (e.target.dataset) {
                  intervalNum = parseInt(e.target.attributes['data-interval'].value);
                } else {
                  intervalNum = parseInt(e.target.getAttribute('data-interval'));
                }

                if (!timeIndicatorElement) {
                  timeIndicatorElement = $(timeIndicatorTemplate).css({left: 10 * intervalNum - 15});
                  quarterHourIntervalContainer.append(timeIndicatorElement);
                  initTimeTooltips();
                }

                drawnShift.startTime = getDateForIntervalNum(intervalNum);
                updateTimes();

                autoHoverOutTimeout = $timeout(function() {
                  if (timeIndicatorElement) {
                    timeIndicatorElement.remove();
                    timeIndicatorElement = null;
                  }
                }, 2000);
              }, 200);
            }
          }, function(e) {
            if (hoverInTimeout) {
              $timeout.cancel(hoverInTimeout);
            }

            if (timeIndicatorElement) {
              timeIndicatorElement.remove();
              timeIndicatorElement = null;
            }

          });
        };

        quarterHourIntervalContainer.on('mousedown touchstart', function(event) {
          var intervalNum;
          var target = event.target;

          if (!event.target.dataset) {
            // IE10 hackery
            if (event.target.getAttribute('class') == 'inner') {
              target = event.target.parentElement;
            } else {
              target = event.target;
            }
          }

          // only respond to left click for now...
          if (event.which === 1 || (event.which === 0 && event.type === 'touchstart')) {

            // if there is already an interactElement check to see if this click is on it
            if (state.interactElement) {

              if (target !== state.interactElement[0] &&
                _.all(target.classList, function(c) {return c !== 'no_clear';})) {
                  reinitBar();
              }
            } else {
              if (target.dataset) {
                intervalNum = parseInt(target.attributes['data-interval'].value);
              } else {
                intervalNum = parseInt(target.getAttribute('data-interval'));
              }

              state.interactElement = element.find('.quarter-hour-interval[data-interval="' + intervalNum + '"]');
              state.interactElement.addClass('active');

              element.find('.quarter-hour-interval-container')
                .addClass('interacting')
                .append('<div class="quarter-hour-interval included manual" data-interval="' + intervalNum + '" style="' + target.style.cssText + '"><div class="inner"></div></div>');
              drawnShift = {
                initInterval: intervalNum,
                startTime: getDateForIntervalNum(intervalNum),
                endTime: getDateForIntervalNum(intervalNum + 1)
              };
              //console.log('drawnShift', drawnShift.initInterval, drawnShift.startTime.format());

              var surroundingOffsetLeft = scrollContainer.offset().left;

              state.interactElement.html($compile(genActiveIntervalInnerTemplate(drawnShift.startTime.twix(drawnShift.endTime)))(scope));
              state.timeContainer = state.interactElement.find('.shift_time_container');
              initTimeTooltips();

              $(document).keyup(function(e) {
                if (e.keyCode === 27) {
                  cleanupBinds();
                  reinitBar();
                }
              });

              if (timeIndicatorElement) {
                _.each(allQuarters, function(q) {
                  q.unbind('mouseenter mouseleave');
                });
                timeIndicatorElement.remove();
              }

              $('body').on('mousemove touchmove', function(event) {
                //console.log(event.type, event);

                //iPad Safari Hackery
                var pageX = event.type === 'mousemove' ? event.pageX : event.originalEvent.pageX;

                var theCurrentIntervalNum = Math.floor((pageX - surroundingOffsetLeft + scrollContainer.scrollLeft()) / 10);
                var startInterval, endInterval;

                if (drawnShift.initInterval <= theCurrentIntervalNum) {
                  startInterval = drawnShift.initInterval;
                  endInterval = theCurrentIntervalNum;
                } else {
                  startInterval = theCurrentIntervalNum;
                  endInterval = drawnShift.initInterval;
                }

                drawnShift.startTime = getDateForIntervalNum(startInterval);
                drawnShift.endTime = getDateForIntervalNum(endInterval + 1);

                state.interactElement.css({
                  left: startInterval * 10,
                  width: (endInterval - startInterval + 1) * 10
                });

                // Find intervals affected and add included class
                _.each(_.range(theCurrentIntervalNum - 10, theCurrentIntervalNum + 10), function(idx) {
                  if (idx > -1 && idx <= (allQuarters.length -1) && idx  !== startInterval) {
                    if (idx < startInterval || idx > endInterval) {
                      allQuarters[idx].removeClass('included');
                    } else {
                      allQuarters[idx].addClass('included');
                    }
                  }
                });

                updateTimes();

                event.stopPropagation && event.stopPropagation();
                event.preventDefault && event.preventDefault();
              });

              var cleanupBinds = function() {
                $('body').off('mousemove touchmove');
                $('body').off('mouseup touchend');
                $(document).off('keyup');
              };

              $('body').on('mouseup touchend', function(event) {
                cleanupBinds();
                scope.addShift();
                event.stopPropagation && event.stopPropagation();
                event.preventDefault && event.preventDefault();
              });
            }
            event.stopPropagation && event.stopPropagation();
            event.preventDefault && event.preventDefault();
          } else if (event.which === 3) {
            // right click cancels

            reinitBar();
          }
        });


        scope.addShift = function() {
          var nowTime = TimeService.getNowInStoreTime();

          if (nowTime.isAfter(drawnShift.startTime)) {
            toastr.error('Cannot draw shift that starts in the past.', 'Error');
            reinitBar();
          } else if (drawnShift.startTime.twix(drawnShift.endTime).length('minutes') < 30) {
            toastr.error('Cannot draw shift less than 30 minutes in length. Click and drag your further to create a longer shift.', 'Error');
            reinitBar();
          } else {
            var data = {
              position_id: scope.position.id,
              organization_id: scope.position.organization_id,
              start_time: drawnShift.startTime.utc().format(),
              end_time: drawnShift.endTime.utc().format()
            };

            state.interactElement.addClass('creating');

            WorkPeriods.create(data)
              .then(function(wp) {
                WorkPeriodStore.addWorkPeriod(wp)
                  .then(function() {
                    if (scope.position._collapsed) {
                      scope.position.toggleCollapsedProperty();
                    }
                    scope.$emit('sa:manageWorkPeriod:dateChange', scope.currentDate);
                  });

                reinitBar();
              }, function() {
                reinitBar();
              });
          }
        };

      }
    };
  });
